import Swiper from 'swiper/swiper-bundle';

export function ticker() {
  const swiper = new Swiper('.section-clients__slider', {
    speed: 2500,
    loop: true,
    slidesPerView: 'auto',
    allowTouchMove: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    breakpoints: {
      0: {
        spaceBetween: 48,
      },
      1024: {
        spaceBetween: 85,
      },
    },
  });
}


// WEBPACK FOOTER //
// app/scripts/components/ticker.js